<template>
  <div class="container py-4">
    <h1 class="mb-4">My Account</h1>

    <div class="content mb-4">
      <div class="card-body">
        <h5 class="card-title">Welcome, {{ user?.user }}</h5>
        <p class="card-text">Email: {{ user?.email }}</p>
      </div>
    </div>

    <div class="content mb-4">
      <div class="card-header">
        Order History
      </div>
      <div class="card-body">
        <div v-if="loading">Loading orders...</div>
        <div v-else-if="orders.length === 0">No orders yet.</div>
        <ul class="list-group list-group-flush">
          <li v-for="order in orders" :key="order.id" class="list-group-item mb-4">
            <router-link :to="`/order-complete/${order.id}`" class="text-decoration-none d-block">
              <div class="d-flex justify-content-between">
                <div>
                  <strong>#{{ order.id }}</strong>
                  <div class="small text-muted">{{ formatDateTime(order.createdAt) }}</div>
                  <div class="small text-muted">
                    {{ order.collection ? 'Collection' : 'Delivery' }} to {{ order.address }}
                  </div>
                </div>
                <div class="text-end">
                  <div>£{{ order.totalAmount.toFixed(2) }}</div>
                  <span class="badge bg-secondary text-capitalize">{{ order.orderStatus }}</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useAuthStore, fetchWithOrWithoutAuth, fetchWithAuth, refreshToken, startTokenRefreshTimer } from 'shared-vue'

  const authStore = useAuthStore()
  const user = authStore.user

  const orders = ref([])
  const loading = ref(true)

  const fetchOrders = async () => {
    try {
      const result = await fetchWithAuth('/publicorder/my-orders')
      if (!result.ok) throw new Error('Failed to fetch orders')
      orders.value = await result.json()
      console.log(orders.value)
    } catch (err) {
      console.error('Failed to load orders:', err)
    } finally {
      loading.value = false
    }
  }

  onMounted(fetchOrders)

  const formatDateTime = (dateString) => {
    const date = new Date(dateString)
    return `${date.toLocaleDateString()} at ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
  }

</script>

<style scoped>
  .container {
    max-width: 800px;
  }
  .list-group-item:first-child {
    border-radius: 5px;
  }
  .list-group-item {
    transition: background-color 0.2s ease;
    background-color: #cccccc11;
    border-radius: 5px;
  }

    .list-group-item:hover {
      background-color: #cccccc33;
    }
</style>
